import { AnswerService, AnswerTrace, FlagService, ListOfFlags, Question, SmartFormLogicService, SmartFormTypeService, TaxReturnService, CommentService, MissingInformationService, SendWarningAndmissingInformationToClientRequest, WarningMissingInformation, SendAnsWarningToClientRequest, SendAnsFlagToClientRequest } from "../../../../../swaggerServices";
import { IDocumentMetadata, ITaxReturn } from "../model/i-tax-return";
import {Component, ElementRef, Input, OnInit, Output, EventEmitter, ViewChild, OnDestroy} from "@angular/core";
import { TRANSLOCO_SCOPE} from '@jsverse/transloco';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TaxReturnSubcategoryService } from "../subcategory/subcategory.service";
import { ProcessStatePollingService } from "./../../../../shared/services/process-state-polling.service";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription, Observable } from "rxjs";
import { ProcessStates } from "../../../../shared/types/processState";
import { ISubGroup, ICommentField, PastedDocMetadata, IAnswerFlag, IFlaggedAns, ICommentWithAnswersTree, ICommentAnswerRequestNode } from "../subcategory/subcategory";
import { ActivatedRoute } from "@angular/router";
import { TaxReturnsResolver } from "../../tax-returns-resolver";
import { cloneDeep } from "lodash-es";
import moment from "moment";
import { IComment } from "../subcategory/comments/comments.component";
import { findUrls, handleUrls, parseMessageForDocumentsAndUrls } from "../urls";
import {
  getFullTaxReturn,
  handleUrlsForNewComment,
  uniqueCommentsForAnswers,
  uniqueOpenWarningsForAnswers,
  uniqueOpenFlagsForAnswers,
  mergeUniqueIds,
  uniqueDocumentsForAnswers,
  resolveDocuments
} from "../../get-full-tax-return";
import {
  SmartFormLogicExtended,
  evaluateNode,
  getTriggeringQuestionIdAndRootNodeIdMap,
  getTriggeringQuestionsForNode,
  getQuestionAnswersFromSmartForm,
  evaluateConditionalLogics,
} from "../../../settings/smart-forms/smart-form-logic-utils";
import { ConfigStateService } from "../../../config/config-state.service";
import { IAnswer, IAnswerWarning, IFormField, makeControlForQuestion, setupDependantMandatory } from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { UserInfoService } from "../../../user-info.service";
import { Tenant } from "../../../../shared/types/tenant.enum";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";
import { BaseURLService } from "../../../../shared/util/baseUrl.service";
import { RubixDocumentsService } from "../rubix-documents/rubix-documents.service";
import { TaxReturnStatus } from "../model/status";

declare var $: any;
const el = elementRef => $(elementRef.nativeElement);
const commentFieldsMatch = (cf1, cf2) => cf1.id === cf2.id && cf1.rowIndex == cf2.rowIndex;
@Component({
    selector: "app-smart-form-view",
    templateUrl: "./smart-form-view.component.html",
    styleUrls: ["./smart-form-view.component.scss"],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: "tax-returns", alias: "taxReturns" }
        }
    ],
    standalone: false
})
export class SmartFormViewComponent implements OnInit, OnDestroy {
  ready = false;
  smartFormTypeId: number;
  taxReturnId: number;
  taxYear = 2022;
  isSaving: boolean;
  isRunningCalcs: boolean;
  isClientResponseLoading: boolean;
  isSyncingAps: boolean;
  isClearingOverrides: boolean;
  commentFields: ICommentField[] = [];
  comments: IComment[];
  comment: UntypedFormControl;
  smartForm;
  questionAnswerMap;
  triggeringQuestionIdAndRootNodeIdsMap; // used to look up the root node when a question is answered
  computedResultMap = {};
  hiddenAndMandatoryMap = {};
  inputQuestionId: number;
  newSubGroupName: string;
  newSubGroupHash: string;
  newSubGroupOrder: number;
  newSubGroupFolderPath: string;
  newSubGroupDocRegexPattern: string;
  commentDocumentMetadatas: PastedDocMetadata[] = [];
  private unsubscribe: Subject<void> = new Subject();
  subGroups;
  @Input() rowIndex;
  @Input() subGroup;
  @Input() readonly;
  @Input() inspectMode;
  @Input() deleted;
  @Input() groupId;
  @Input() rowAnswer;
  @Input() modernTable?: boolean;

  // @Output() loadTrace = new EventEmitter();
  @Output() selectRow = new EventEmitter();
  @Output() refreshTaxReturn: EventEmitter<any> = new EventEmitter();

  @ViewChild("saveModal") saveModal: ElementRef;
  answerWarnings: IAnswerWarning[] = [];
  savedAnswersWithFlags: IAnswerFlag[] = []; // to prompt closing flags
  savedAnswersWithWarnings: IAnswerWarning[] = [];
  answerFlags: IAnswerFlag[] = [];
  @ViewChild("answerFlagsModal") answerFlagsModal: ElementRef;
  @ViewChild("answerWarningsModal") answerWarningsModal: ElementRef;
  @ViewChild("calcResultsModal") calcResultsModal: ElementRef;
  calcResultsSummary: string[] = [];
  calcFailures: string[] = [];
  calcDebug: string[] = [];
  showCalcDebug: boolean = false;
  isAdmin: boolean = false;

  // from subcategory
  taxReturn: ITaxReturn;
  getCommentMeta: Function; // shared to comments cmp
  handleCommentReply: Function; // shared to comments cmp
  formGroup: UntypedFormGroup;
  subscriptions = []; // TODO: clean this up on destroy
  isReady = false;
  debugModeControl: UntypedFormControl = new UntypedFormControl();
  debug = !!this.debugModeControl.value;
  uiConfig: TenantConfigService;

  //RH sidebar
  showQuestionId: boolean;
  rightSideTab: 'activity' | 'calculation' = 'activity';
  trace?: AnswerTrace;
  traceQuestion?: Question;
  traceAnswer?: IAnswer;
  loadingTrace?: Subscription;
  tab = 2; // default to comments tab
  activeCategory: any;
  // activeGroup: IGroup; // current group in focus
  smarFormWithCount;
  commentsCount: number; // total comments for subcategory
  totalComments = 0; // total comments count for selected group or subgroup
  fileQuestion: any[];
  filteredDocuments: IDocumentMetadata[];
  flaggedAns?: IFlaggedAns;
  flagsComment: UntypedFormControl = new UntypedFormControl();
  flagTypes: ListOfFlags;
  flagTypeId: number; // when adding new comment with flags
  @ViewChild('flagDropDown') flagDropDown: ElementRef;
  answerFlagsFiltered: IAnswerFlag[] = [];
  replyingWarning = false;
  replyingFlag = false;
  @ViewChild('unsavedFieldsModal') unsavedFieldsModal: ElementRef;
  groupQuestion?: IFormField; // question field set as group tab
  defaultGroupName = 'untitled';
  isFullScreenMode: boolean = false;
  validationWarnings: any
  maxNumOfComments: number = 2

  scrollToQuestionId: number
  lastScrollFragment?: string;
  isPublishedInOT: boolean = false
  _sideOpen = true;
  get sideOpen() {
    return this._sideOpen;
  }

  set sideOpen(open: boolean) {
    this._sideOpen = open;
    // NOTE(mike): super hack to fix the floatThead jquery plugin issue where it doesn't handle the resize
    // caused by opening/closing the side-block.
    window.dispatchEvent(new Event('resize'));
  }
  previousSideOpen = this.sideOpen

  get isLodged(): boolean {
    return (this.taxReturn && (
      this.taxReturn.status === TaxReturnStatus.LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.AMENDMENT_LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.REVISION_LODGED.id
    ));
  }
  get disableRunCalcForLodgedTaxReturn(): boolean {
    return this.config.featureFlags.disableRunCalcForLodgedTaxReturn;
  }

  overRideFlag = '';
  constructor(
    private activatedRoute: ActivatedRoute,
    private smartFormService: SmartFormTypeService,
    private smartFormLogicService: SmartFormLogicService,
    private taxReturnsResolver: TaxReturnsResolver,
    private ProcessStatePollingService: ProcessStatePollingService,
    private taxReturnService: TaxReturnService,
    private config: ConfigStateService,
    private userInfo: UserInfoService,
    private taxReturnSubcategoryService: TaxReturnSubcategoryService,
    private answerService: AnswerService,
    private commentService: CommentService,
    private flagService: FlagService,
    private missingInformation: MissingInformationService,
    private baseUrl: BaseURLService,
    private rubixDocumentService: RubixDocumentsService,
  ) {}

  ngOnInit() {
    this.taxReturnId = +this.activatedRoute.params["value"]["id"];
    this.smartFormTypeId = +this.activatedRoute.params["value"]["smartFormId"];

    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.inputQuestionId = Number(queryParams.question);
    });
    this.isClientResponseLoading=false;
    this.subGroups = {};

    this.smartFormService.getSmartFormsByTaxReturnId(this.taxReturnId).subscribe((result: any) => {
      this.smartForm = result.find(val => val.id === this.smartFormTypeId);
      this.smartForm = this.addAnswersToQuestions(this.smartForm);
      if (this.taxReturn) {
        this.formGroup = this.buildFormForSmartForm();
      }

      this.logicComputation()
      this.countWarningsFlagsComments()
      this.ready = true;
      this.detectFormChanges();

      this.smartFormService.getSentSmartFormRequests(this.taxReturnId).subscribe((smartFormRequest: any) => {
        if (smartFormRequest.some(r => r.smartFormTypeId === this.smartForm.id && r.otRequestId && r.syncDate)) {
          this.isPublishedInOT = true
        }
      })
    })

    this.config.loadConfig().subscribe(config => {
      this.showQuestionId = config.tenant !== Tenant.AU;
      this.uiConfig = new TenantConfigService(config);
    });
    this.isAdmin = !!this.userInfo.isAdmin;
    this.debug =
      this.userInfo.isAdmin &&
      this.activatedRoute.snapshot.queryParams.debug != null;

    this.debugModeControl.statusChanges.subscribe(newVal => {
      this.debug = this.debugModeControl.value;
      this.applyDebug();
      this.formGroup = this.buildFormForSmartForm();
      this.detectFormChanges();
    });

    this.taxReturnsResolver.getTaxReturnObs().subscribe((taxReturn: any) => {
      this.taxReturn = cloneDeep(taxReturn);
      this.taxYear = taxReturn.year;
      //this.applyDebug();
      this.rubixDocumentService.setTaxReturnForImageUploads(this.taxReturn);

      // shared function to append ui meta to warnings and comments
      this.getCommentMeta = (c: IComment) => {
        let user;
        let role;
        if (
          c.commentAudits &&
          c.commentAudits.length &&
          this.taxReturn &&
          this.taxReturn.preparer &&
          this.taxReturn.preparer.find(p => p.id === c.commentAudits[0].userId)
        ) {
          user = this.taxReturn.preparer.find(
            p => p.id === c.commentAudits[0].userId
          );
          role = "Preparer";
        } else if (
          c.commentAudits &&
          c.commentAudits.length &&
          this.taxReturn &&
          this.taxReturn.reviewer &&
          this.taxReturn.reviewer.find(p => p.id === c.commentAudits[0].userId)
        ) {
          user = this.taxReturn.reviewer.find(
            p => p.id === c.commentAudits[0].userId
          );
          role = "Reviewer";
        } else {
          user =
            c.commentAudits && c.commentAudits.length
              ? c.commentAudits[0]["user"]
              : null;
          role = "";
        }

        const author = user
          ? user.firstName + " " + user.lastName
          : c.autoDocLink
          ? "Auto generated"
          : "Unknown User";
        role = role ? role : c.autoDocLink ? "System" : "Unknown role";

        const m = moment(c.createdAt);
        return {
          id: c.id,
          message: c.message,
          parts: c.parts,
          author,
          role,
          date: m.format("MMMM Do YYYY, h:mm:ss a"),
          dateMoment: m,
          isReply: c.parentCommentId,
          externalUrl: c.externalUrl,
          hasSentToClient: c.hasSentToClient,
        };
      };

      this.handleCommentReply = (newComment: IComment) => {
        handleUrlsForNewComment(
          this.taxReturnService,
          this.taxReturn,
          newComment
        ).subscribe(hasNewDocs => {
          if (hasNewDocs) {
            this.onCategoryChange();
          }
        });
      };
      if (this.ready) {
        this.formGroup = this.buildFormForSmartForm();
        this.setValidatorRequiredToFormGroup()
        this.detectFormChanges();
      }
    });

    this.comment = new UntypedFormControl("");
    this.commentDocumentMetadatas = [];
    this.subscriptions.push(
      this.comment.valueChanges.subscribe(newVal => {
        // NOTE(mike): Hack workaround to propagate the form control value to every view
        // the form control is bound to. Without this, using a formControl in 2 inputs will
        // not two-way bind. :(
        this.comment.setValue(newVal, {
          emitEvent: false,
          emitViewToModelChange: false
        });

        // also parse doc links
        const urls = findUrls(newVal).map(({ url }) => url);
        handleUrls(
          urls,
          this.commentDocumentMetadatas,
          this.taxReturnService
        ).then(
          (data: PastedDocMetadata[]) => (this.commentDocumentMetadatas = data)
        );
      })
    );

    this.subscriptions.push(
      this.taxReturnSubcategoryService.commentFieldsChanged.subscribe(
        commentFields => {
          this.commentFields = commentFields;
        }
      )
    );

    this.taxReturnSubcategoryService.setCommentFields([]);
    this.isReady = false;


  }

  logicComputation() {
    this.questionAnswerMap = getQuestionAnswersFromSmartForm(this.smartForm);
    this.triggeringQuestionIdAndRootNodeIdsMap = getTriggeringQuestionIdAndRootNodeIdMap(this.smartForm.SmartFormLogic);
    this.computedResultMap = evaluateConditionalLogics(this.smartForm, this.questionAnswerMap);
    this.hiddenAndMandatoryMap = this.calculateHiddenAndMandatoryMap(this.smartForm, this.computedResultMap);
  }

  setValidatorRequiredToFormGroup() {
    Object.keys(this.hiddenAndMandatoryMap).forEach(key => {
      const keyElements = this.parseKey(key);
      if (!keyElements) {
        return;
      }
      const control = this.getFormControl(keyElements.entityId, null);
      if (keyElements.entity === 'question' && control) {
        if (this.hiddenAndMandatoryMap[key].mandatory && !control.hasValidator('required')) {
          control.addValidators(Validators.required);
          control.markAsDirty();
          if (!control.value) {
            control.setErrors({...control.errors, required: true});
          }
        } else {
          control.removeValidators(Validators.required);
          if (control.hasError('required')) {
            delete control.errors.required;
            if (Object.keys(control.errors).length === 0) {
              control.setErrors(null);
            }
          }
        }
      }
    });
  }

  detectFormChanges() {
    const subGroupsArray = Object.values(this.subGroups) as ISubGroup[];
    // Handle subgroup answer changes
    subGroupsArray.forEach(sg => {
      if (!sg.isTable) {
        sg.questions.forEach(sgq => {
          const control = this.getFormControl(sgq.id, null);
          const sub = control.valueChanges.subscribe(newVal => {
             this.handleAnswerChange(control, sgq, newVal, sg)
          }
          );
          this.handleAnswerChange(control, sgq, control.value, sg);
        });
      }
    });

    this.subscriptions.push(this.taxReturnSubcategoryService.flaggedAnsChanged.subscribe(flaggedAns => {
      this.flaggedAns = flaggedAns;
    }));
  }

  calculateHiddenAndMandatoryMap(smartForm, computedResultMap) {
    const hiddenAndMandatoryMap = {};

    for (const smartFormCategory of smartForm.smartFormCategories) {

      for (const smartFormSubCategory of smartFormCategory.smartFormSubCategories) {

        for (const smartFormQuestion of smartFormSubCategory.smartFormQuestions) {
          const questionHiddenAndMandatory = this.calculateQuestionHiddenAndMandatory({
            smartFormQuestion,
            subCategoryId: smartFormSubCategory.id,
            categoryId: smartFormCategory.id,
          });
          smartFormQuestion.hidden = questionHiddenAndMandatory.hidden;
          smartFormQuestion.mandatory = questionHiddenAndMandatory.mandatory;
          smartFormQuestion.triggeringQuestionIds = questionHiddenAndMandatory.triggeringQuestionIds;

          const questionKey = this.buildKey('question', smartFormQuestion.questionId);
          hiddenAndMandatoryMap[questionKey] = questionHiddenAndMandatory;
        }

        const subCategoryHiddenAndMandatory = this.calculateSubCategoryHiddenAndMandatory({
          subCategory: smartFormSubCategory,
          categoryId: smartFormCategory.id,
          hiddenAndMandatoryMap,
        });
        smartFormSubCategory.hidden = subCategoryHiddenAndMandatory.hidden;
        smartFormSubCategory.mandatory = subCategoryHiddenAndMandatory.mandatory;
        smartFormSubCategory.triggeringQuestionIds = subCategoryHiddenAndMandatory.triggeringQuestionIds;

        const subCategoryKey = this.buildKey('smartFormSubCategory', smartFormSubCategory.id);
        hiddenAndMandatoryMap[subCategoryKey] = subCategoryHiddenAndMandatory;
      }

      const categoryHiddenAndMandatory = this.calculateCategoryHiddenAndMandatory({
        category: smartFormCategory,
        hiddenAndMandatoryMap,
      })
      smartFormCategory.hidden = categoryHiddenAndMandatory.hidden;
      smartFormCategory.mandatory = categoryHiddenAndMandatory.mandatory;
      smartFormCategory.triggeringQuestionIds = categoryHiddenAndMandatory.triggeringQuestionIds;

      const categoryKey = this.buildKey('smartFormCategory', smartFormCategory.id);
      hiddenAndMandatoryMap[categoryKey] = categoryHiddenAndMandatory;
    }

    return hiddenAndMandatoryMap;
  }

  calculateQuestionHiddenAndMandatory({ smartFormQuestion, subCategoryId, categoryId }) {
    const categoryCombinedComputedResult = this.getCombinedComputedResult('smartFormCategory', categoryId);
    const subCategoryCombinedComputedResult = this.getCombinedComputedResult('smartFormSubCategory', subCategoryId);
    const questionCombinedComputedResult = this.getCombinedComputedResult('question', smartFormQuestion.questionId);
    const mandatory = categoryCombinedComputedResult.mandatory || subCategoryCombinedComputedResult.mandatory || questionCombinedComputedResult.mandatory;
    const question = smartFormQuestion.questions[0];

    if (question.hidden || smartFormQuestion.hideForPreparer) {
      return {
        hidden: true,
        mandatory,
      }
    }

    if (
      smartFormQuestion.showByDefault ||
      questionCombinedComputedResult.show ||
      subCategoryCombinedComputedResult.show ||
      categoryCombinedComputedResult.show
    ) {
      return {
        hidden: false,
        mandatory,
        triggeringQuestionIds: questionCombinedComputedResult?.triggeringQuestionIds,
      }
    }

    return {
      hidden: true,
      mandatory,
    }
  }

  calculateSubCategoryHiddenAndMandatory({ subCategory, categoryId, hiddenAndMandatoryMap }) {
    const subCategoryCombinedComputedResult = this.getCombinedComputedResult('smartFormSubCategory', subCategory.id);
    const categoryCombinedComputedResult = this.getCombinedComputedResult('smartFormCategory', categoryId);
    const mandatory = categoryCombinedComputedResult.mandatory || subCategoryCombinedComputedResult.mandatory;
    const hasAnyChildrenShowed = subCategory.smartFormQuestions
      .some(smartFormQuestion => !hiddenAndMandatoryMap[this.buildKey('question', smartFormQuestion.questionId)].hidden);
    const hidden = !(hasAnyChildrenShowed || subCategoryCombinedComputedResult.show || categoryCombinedComputedResult.show);
    return {
      hidden,
      mandatory,
      triggeringQuestionIds: subCategoryCombinedComputedResult?.triggeringQuestionIds,
    }
  }

  calculateCategoryHiddenAndMandatory({ category, hiddenAndMandatoryMap }) {
    const categoryCombinedComputedResult = this.getCombinedComputedResult('smartFormCategory', category.id);
    const mandatory = categoryCombinedComputedResult.mandatory;
    const hasAnyChildrenShowed = category.smartFormSubCategories
      .some(smartFormSubcategory => !hiddenAndMandatoryMap[this.buildKey('smartFormSubCategory', smartFormSubcategory.id)].hidden);
    const hidden = !(hasAnyChildrenShowed || categoryCombinedComputedResult.show);
    return {
      hidden,
      mandatory,
      triggeringQuestionIds: categoryCombinedComputedResult?.triggeringQuestionIds,
    }
  }

  getCombinedComputedResult(entity, entityId) {
    const computedResults = this.computedResultMap[this.buildKey(entity, entityId)];
    if (!computedResults) {
      return {
        show: false,
        mandatory: false,
      }
    }
    const computedResulArray = Object.keys(computedResults).map(key => computedResults[key]);
    const show = computedResulArray.some(computedResult => computedResult.show);
    const mandatory = computedResulArray.some(computedResult => computedResult.mandatory);
    const triggeringQuestionIds = computedResulArray.find(computedResult => computedResult.show)?.triggeringQuestionIds;
    return {
      show,
      mandatory,
      triggeringQuestionIds,
    }
  }

  buildKey(entity, entityId) {
    return `${entity}-${entityId}`;
  }

  parseKey(key) {
    const elements = key.split("-");
    if (elements.length !== 2) {
      return null;
    }
    return { entity: elements[0], entityId: elements[1] };
  }

  handleAnswerChange(control, question, newVal, subgroup, rowIndex?: number) {
    // NOTE(mike): Hack workaround to propagate the form control value to every view
    // the form control is bound to. Without this, using a formControl in 2 inputs will
    // not two-way bind. :(

    newVal = newVal == null || newVal === false ? "" : String(newVal);

    if (subgroup) {
      question.subGroupId = subgroup.id;
      question.subGroupName = subgroup.name;
    }

    const answer =
      rowIndex != null
        ? subgroup.rows[rowIndex].cells[question.id]
        : question.answers.length > 0
        ? question.answers[0]
        : null;
    const originalAnswer =
      answer && !answer.isNew && answer.answer != null ? answer.answer : "";
    let valueHasChangedFromOriginal = newVal !== originalAnswer;

    if (
      question.displayFieldType === "checkbox" &&
      question.answers.length === 0 &&
      question.default === "true"
    ) {
      valueHasChangedFromOriginal = true;
    }

    this.foreachSmartFormQuestion(sfQ => {
      if(sfQ.questionId === question.id) {
        if (question.answers.length) {
          sfQ.answers[0].answer = newVal
        }else {
          sfQ.answers = valueHasChangedFromOriginal ? [{answer: newVal}] : []
        }
      }
    })

    const originalHiddenAndMandatoryMap = {...this.hiddenAndMandatoryMap}
    this.logicComputation()
    this.resetAnswerOfHiddenQuestion(question, originalHiddenAndMandatoryMap)
    this.setValidatorRequiredToFormGroup()
    this.countWarningsFlagsComments()

    const commentField = cloneDeep(question);
    commentField.answerChanged = valueHasChangedFromOriginal;
    commentField.rowIndex = rowIndex;

    // remove from array if val is same as previous
    if (!valueHasChangedFromOriginal) {
      const qInArr = this.commentFields.find(cf =>
        commentFieldsMatch(cf, commentField)
      );
      // Remove when the commentField was due to an answer change
      if (qInArr && qInArr.answerChanged) {
        this.taxReturnSubcategoryService.removeCommentField(qInArr);
      }
    } else {
      const qInArr = this.commentFields.find(cf =>
        commentFieldsMatch(cf, commentField)
      );
      if (qInArr) {
        // Edit when the commentField was not due to an answer change, but now is

        const updatedCommentFields = this.commentFields.map(cf =>
          cf === qInArr ? { ...qInArr, answerChanged: true } : cf
        );
        this.taxReturnSubcategoryService.setCommentFields(updatedCommentFields);
      } else {
        const groupQuestionDuplicated =
          !subgroup &&
          this.subGroups.some(sg =>
            sg.questions.some(q => q.id === question.id)
          );
        if (
          !this.isQuestionAlwaysEditable(question, undefined) &&
          (subgroup || !groupQuestionDuplicated)
        ) {
          this.taxReturnSubcategoryService.addCommentField(commentField);
        }
      }
    }
  }

  resetAnswerOfHiddenQuestion(question, originalHiddenAndMandatoryMap) {
    const resetQuestion = (questionId) => {
      const originalQuetionInSubGroups = this.subGroups[questionId]
      if (originalQuetionInSubGroups.isTable) {
        originalQuetionInSubGroups.rows.forEach((row, rowIndex) => {
          Object.keys(row.cells).forEach(key => {
            this.formGroup.removeControl(`${key}-${rowIndex}`)
            row.cells[key].answerChanged = false
            const commentField = this.commentFields.find(c => c.id === Number(key))
            if (commentField) {
            this.taxReturnSubcategoryService.removeCommentField(commentField);
            }
          })
        })
      }else {
        const control = this.getFormControl(questionId, null);
        const originalAnswerInSubGroups = originalQuetionInSubGroups.questions[0].answers.length ? originalQuetionInSubGroups.questions[0].answers[0].answer : null
        control.setValue(originalAnswerInSubGroups)
      }
    }

    Object.keys(this.hiddenAndMandatoryMap).forEach(key => {
      const splitKey = key.split("-")

      if (this.hiddenAndMandatoryMap[key].hidden &&
        originalHiddenAndMandatoryMap[key].triggeringQuestionIds &&
        originalHiddenAndMandatoryMap[key].triggeringQuestionIds.some(id => id === question.id)) {
        switch (splitKey[0]) {
          case "question": {
            resetQuestion(splitKey[1])
            break;
          }
          case "smartFormSubCategory": {
            this.smarFormWithCount.smartFormCategories.forEach(category => {
              const hiddenSubCategory = category.smartFormSubCategories.find(subcat => subcat.id === Number(splitKey[1]))
              hiddenSubCategory && hiddenSubCategory.smartFormQuestions.forEach(q => {
                resetQuestion(q.questionId)
              })
            })
            break;
          }
          case "smartFormCategory": {
            const hiddenCategory = this.smarFormWithCount.smartFormCategories.find(cat => cat.id === Number(splitKey[1]))
            hiddenCategory.questions.forEach(q => {
              resetQuestion(q.questionId)
            })
            break;
          }
          default:
            break;
        }

      }
    })
  }

  // add subgroup
  createSubgroup() {
    const subgroup = {
      id: "",
      name: "",
      folderPath: "",
      isTable: true,
      hint: null,
      docRegexPattern: "",
      hash: "",
      newSubGroupOrder: "",
      question: "",
      questions: [],
      rows: []
    };

    return subgroup;

    // add to list
    // this.subgroups.push(subgroup);
  }

  assignSubgroup(smartFormQuestions, isTable) {
    if (isTable) {
      return this.buildSubgroupForTableQuestion(smartFormQuestions);
    } else {
      return this.buildSubgroupForNonTableQuestion(smartFormQuestions);
    }
  }

  buildQuestionArrayForNonTable(smartFormQuestions) {
    const questionArray = [];

    smartFormQuestions.questions.forEach(question => {
      const questionObj = { ...question, answers: [] };
      questionArray.push(questionObj);
    });

    return questionArray;
  }

  buildQuestionArrayForTable(smartFormQuestions) {
    const questionArray = [];

    smartFormQuestions.dependentQuestions.forEach((question, index) => {
      const answers = smartFormQuestions.dependentAnswers[index]
      const questionObj = {
        ...question,
        answers: answers? answers.map(answer => {
          const comments = answer.comments.map(comment => {
            const data = parseMessageForDocumentsAndUrls(comment.message || "");
            const commentAudits = comment.commentAudits.map(audit => {
              return { ...audit };
            });

            return { ...comment, commentAudits: commentAudits, parts: data.parts,
              documents: data.documents };
          });
          return { ...answer, comments: comments };
        }) : null,
      };

      if (questionObj.mandatory) {
        questionObj.warningMessage = answers.length
                                    ? undefined : "Unanswered Mandatory Field"
      }

      questionArray.push(questionObj);
    });

    return questionArray;
  }

  buildSubgroupForNonTableQuestion(smartFormQuestions: any): any {
    if (!smartFormQuestions) return [];
    const subGroup = this.createSubgroup();

    // Check if the displayFieldType is "table"

    // Construct the subgroup object
    subGroup.id = smartFormQuestions.questions[0].id;
    subGroup.name = smartFormQuestions.questions[0].question;
    subGroup.hint = null;
    subGroup.isTable = false;
    subGroup.questions = this.buildQuestionArrayForNonTable(smartFormQuestions);

    // Loop through SmartFormQuestions.answers and build the rows array
    if (smartFormQuestions.answers == null) {
      smartFormQuestions.answers = [];
    }
    smartFormQuestions.answers?.forEach(answer => {
      let commentWithUrlsAndDocuments = []
      if (answer.comments) {
        commentWithUrlsAndDocuments = answer.comments.map(comment => {
          const data = parseMessageForDocumentsAndUrls(comment.message || "");
          return {
            ...comment,
            parts: data.parts,
            documents: data.documents
          }
        })

      }
      const rowObj = {
        ...answer,
        comments: commentWithUrlsAndDocuments,
      }
      subGroup.questions[0].answers.push(rowObj);
    });

    if (subGroup.questions[0].mandatory || smartFormQuestions.mandatory) {
      subGroup.questions[0].warningMessage = !subGroup.questions[0].answers.length
                                              ? "Unanswered Mandatory Field" : !subGroup.questions[0].answers[0].answer
                                              ? "Unanswered Mandatory Field" : undefined
    }

    return subGroup;
  }

  buildSubgroupForTableQuestion(smartFormQuestions: any): any {
    if (!smartFormQuestions) return [];
    const subGroup = this.createSubgroup();

    // Check if the displayFieldType is "table"

    // Construct the subgroup object
    subGroup.id = smartFormQuestions.questions[0].id;
    subGroup.name = smartFormQuestions.questions[0].question;
    subGroup.hint = null;
    subGroup.isTable = true;
    subGroup.question = smartFormQuestions.questions[0];
    subGroup.questions = this.buildQuestionArrayForTable(smartFormQuestions);
    subGroup.rows = [];

    // Loop through SmartFormQuestions.answers and build the rows array
    smartFormQuestions.answers.forEach((answer, index) => {
      let commentWithUrlsAndDocuments = []
      if (answer.comments) {
        commentWithUrlsAndDocuments = answer.comments.map(comment => {
          const data = parseMessageForDocumentsAndUrls(comment.message || "");
          return {
            ...comment,
            parts: data.parts,
            documents: data.documents
          }
        })

      }
      const rowObj = {
        rowAnswer: {
          ...answer,
          comments: commentWithUrlsAndDocuments,
        },
        cells: {},
        ordinal: index
      }

      const rowSpecificAnswers = this.getElementsWithParentAnswerId(
        smartFormQuestions.dependentAnswers,
        answer.id
      );
      // Loop through dependent questions and build cells for each row
      rowSpecificAnswers.forEach(rowAnswer => {
        let rowAnswerCommentWithUrlsAndDocuments = []
        if (rowAnswer.comments) {
          rowAnswerCommentWithUrlsAndDocuments = rowAnswer.comments.map(comment => {
            const data = parseMessageForDocumentsAndUrls(comment.message || "");
            return {
              ...comment,
              parts: data.parts,
              documents: data.documents
            }
          })

        }
        rowObj.cells[rowAnswer.questionId] = {
          id: rowAnswer.id,
          answer: rowAnswer ? rowAnswer.answer : "",
          createdAt: rowAnswer ? rowAnswer.createdAt : "",
          updatedAt: rowAnswer ? rowAnswer.updatedAt : "",
          questionId: rowAnswer.questionId,
          taxReturnId: rowAnswer ? rowAnswer.taxReturnId : null,
          parentAnswerId: smartFormQuestions.questions[0].id,
          overrideStatus: rowAnswer ? rowAnswer.overrideStatus : null,
          comments: rowAnswer ? rowAnswerCommentWithUrlsAndDocuments : [],
          answerWarnings: rowAnswer ? rowAnswer.answerWarnings : [],
          answerFlags: rowAnswer ? rowAnswer.answerFlags : [],
          answerAudits: rowAnswer ? rowAnswer.answerAudits : [],
        };
      });

      // Add the row to the rows array
      subGroup.rows.push(rowObj);
    });
    this.subGroup = this.fillUnansweredBlankColumns(subGroup);
    return subGroup;
  }

 fillUnansweredBlankColumns(data: any) {
    const columnIds: string[] = Array.from(
        new Set(data.questions.map((question: any) => question.id.toString()))
    );
    data.rows.forEach((row: any) => {
        const existingColumnIds = Object.keys(row.cells);
        const missingColumnIds = columnIds.filter(id => !existingColumnIds.includes(id));

        missingColumnIds.forEach(columnId => {
            row.cells[columnId] = {
                answer: ""
            };
        });
    });

    return data;
}

  // Function to get elements with parentAnswerId equal to 15993
  getElementsWithParentAnswerId(data, parentAnswerId) {
    const elements = data.flatMap(row =>
      row.filter(obj => obj.parentAnswerId === parentAnswerId)
    );
    return elements;
  }

  applyDebug() {
    if (this.debug) {
      this.foreachSmartFormQuestion(sfQ => {
        if (sfQ.dependentQuestions) {
          sfQ.dependentQuestions.forEach(col => {
            col.actualHidden = col.hidden;
            col.hidden = false;
            col.showTag = col.tag;
            col.debugLinks = true;
          })
        }
        sfQ.questions.forEach(q => {
          q.actualHidden = q.hidden;
          q.hidden = false;
          q.showTag = q.tag;
          q.debugLinks = true;
        })
      });

    } else {
      this.foreachSmartFormQuestion(sfQ => {
        if (sfQ.dependentQuestions) {
          sfQ.dependentQuestions.forEach(col => {
            col.hidden = col.actualHidden;
            col.showTag = undefined;
            col.debugLinks = false;
          })
        }
        sfQ.questions.forEach(q => {
          q.hidden = q.actualHidden;
          q.showTag = undefined;
          q.debugLinks = false;
        })
      });
    }
  }

  // fetches full tax return data. this method is only called on save
  getTaxReturn() {
    const taxReturnId = this.taxReturn.id;
    getFullTaxReturn(this.taxReturnService, taxReturnId, null).subscribe(
      taxReturn => {
        this.taxReturn = taxReturn;
        this.resolveDocuments();
        this.applyDebug();
      }
    );
  }

  resolveDocuments() {
    if (this.taxReturn.documents && this.taxReturn.documents.length) {
      resolveDocuments(this.taxReturnService, this.taxReturn).subscribe(() => {
        this.filterDocuments();
      });
    }
  }

  fetchUpdatedSmartForm() {
    this.smartFormService.getSmartFormsByTaxReturnId(this.taxReturnId).subscribe((result: any) => {
      this.smartForm = result.find(val => val.id === this.smartFormTypeId);
      this.smartForm = this.addAnswersToQuestions(this.smartForm);
      this.formGroup = this.buildFormForSmartForm();
      this.taxReturnSubcategoryService.setCommentFields([]);
      this.detectFormChanges();
      this.countWarningsFlagsComments()
      this.onCategoryChange()
    })
  }

  runCalcs() {
    this.isRunningCalcs = true;
    this.taxReturnService.runTaxReturnCalculations(this.taxReturn.id).subscribe(
      result => {
        this.ProcessStatePollingService.startPolling(
          "runCalcs",
          "taxReturn",
          this.taxReturn.id,
          5000,
          3
        );
        this.getCalcsResults();
      },
      e => {
        this.isRunningCalcs = false;
      }
    );
  }

  getCalcsResults() {
    this.ProcessStatePollingService.subscribeData(
      "runCalcs",
      "taxReturn",
      this.taxReturn.id
    )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        result => {
          this.clearCalcsResults();
          // this.isRunningCalcs = false;
          if (!result || !result.state || !result.message) {
            this.calcResultsSummary = [
              "Unable to get calcs status, system will retry or please re-run calcs again in few minutes."
            ];
            return;
          }
          this.calcResultsSummary = result.message.split("\n");

          const elem = el(this.calcResultsModal);
          elem.modal("show");
          elem.find(".content")[0].scrollTop = 0;
          if (result.state === ProcessStates.CANCELED) {
            this.ProcessStatePollingService.cancelPolling(
              "runCalcs",
              "taxReturn",
              this.taxReturn.id
            );
            this.isRunningCalcs = false;
            this.calcResultsSummary = [
              "Calcs stopped responding and has been automatically cancelled"
            ];
          }
          if (result.state === ProcessStates.FAILED) {
            this.ProcessStatePollingService.cancelPolling(
              "runCalcs",
              "taxReturn",
              this.taxReturn.id
            );
            this.isRunningCalcs = false;
            this.calcResultsSummary = [
              "Calcs has completed Running however it has failed to run successfully"
            ];
          }
          if (result.state === ProcessStates.SUCCESS) {
            this.ProcessStatePollingService.cancelPolling(
              "runCalcs",
              "taxReturn",
              this.taxReturn.id
            );
            this.isRunningCalcs = false;
            this.calcResultsSummary = [
              "Calcs has completed running unsuccessfully"
            ];
            let parsedResult;
            try {
              parsedResult = JSON.parse(result.message);
              const summary = [];
              const failures = [];
              const debugPlans = [];
              if (parsedResult.success) {
                if (parsedResult.comment) {
                  this.isReady = false;
                  this.getTaxReturn();
                }
                summary.push(
                  `Successfully executed ${parsedResult.numSuccesses} plans`
                );
                if (parsedResult.failures && parsedResult.failures.length) {
                  summary.push(
                    `Failed to execute ${parsedResult.failures.length} plans:`
                  );
                  failures.push(...parsedResult.failures.map((f, i) => `${f}`));
                }
                if (this.isAdmin) {
                  if (parsedResult.comment) {
                    summary.push(...(parsedResult.comment.messages || []));
                  }
                  debugPlans.push(...(parsedResult.debug || []));
                }
                this.fetchUpdatedSmartForm();
              } else {
                summary.push(
                  `Failed to run calculations: ${parsedResult.error}`
                );
              }
              this.calcResultsSummary = summary;
              this.calcFailures = failures;
              this.calcDebug = debugPlans;
            } catch (err) {
              this.calcResultsSummary = [result.message];
              this.calcFailures = [];
              this.calcDebug = [];
            }
          }
        },
        e => {
          this.ProcessStatePollingService.cancelPolling(
            "runCalcs",
            "taxReturn",
            this.taxReturn.id
          );
          this.isRunningCalcs = false;
        }
      );
  }

  clearCalcsResults() {
    this.calcResultsSummary = [];
    this.calcFailures = [];
    this.showCalcDebug = false;
  }

  toggleCalcDebug() {
    this.showCalcDebug = !this.showCalcDebug;
  }
  getTaxReturnIdForCategory() {
    return this.taxReturn.id;
  }

  // gets the form control
  getFormControl: Function = (
    q: number,
    rowIndex?: number
  ): AbstractControl => {
    return rowIndex != null
      ? this.formGroup.get(`${q}-${rowIndex}`)
      : this.formGroup.controls[q];
  };
  save(isCommentBox?: boolean) {
    this.isSaving = true;
    const comment: ICommentWithAnswersTree = {
      taxReturnId: this.getTaxReturnIdForCategory(),
      comment: {
        message: this.comment.value
      },
      answers: [],
      forceAnswerIds: []
    };

    Object.keys(this.formGroup.controls).forEach(key => {
      let questionId;
      let rowIndex: number;
      let formControl;
      let q: IFormField;

      // table row questions have id format of tableQuestionId-questionId (eg 123-2). extract the table question id
      if (key.indexOf("-") !== -1) {
        questionId = Number(key.substr(0, key.indexOf("-"))); // table question id
        rowIndex = Number(key.substr(key.indexOf("-") + 1));
      } else {
        questionId = Number(key);
      }
      if (rowIndex != null) {
        formControl = this.getFormControl(questionId, rowIndex);
        const subGroupsArray = Object.values(this.subGroups) as ISubGroup[];
        const sg = subGroupsArray.find(
          sG =>
            sG.isTable &&
            sG.questions.some(question => question.id === questionId)
        );
        // find the existing answer from the subgroups
        const row = sg.rows[rowIndex];
        const existingAnswer = row.cells[questionId];
        const originalAnswerValue =
          existingAnswer && existingAnswer.answer != null
            ? existingAnswer.answer
            : "";
        const formControlValue =
          formControl.value != null ? String(formControl.value) : "";
        const valueChanged = originalAnswerValue !== formControlValue;

        // Need to handle the case of comments without changing an answer
        const targetCf = { id: questionId, rowIndex };
        const isCommentOnly =
          !valueChanged &&
          this.commentFields.some(cf => commentFieldsMatch(cf, targetCf));

        if (valueChanged || isCommentOnly) {
          // prepare cell answer
          const answer: ICommentAnswerRequestNode = {
            questionId: questionId,
            answer: formControlValue,
            overrideStatus: isCommentOnly ? 0 : 1 // modifying any table cell in the UI is an override with status=1
          };

          if (existingAnswer && !existingAnswer.isNew)
            answer.id = existingAnswer.id;

          if (isCommentOnly && answer.id != null) {
            comment.forceAnswerIds.push(answer.id);
          } else {
            const rowIdQ = sg.questions.find(
              qq => qq.isRowId && qq.parentId === sg.id
            );
            const makeManualRowId = () => `manual-${rowIdQ.id}-${crypto.randomUUID()}`;
            // init row answer, if it doesn't already exist
            // const answersArr: any = this.subGroup.question ? comment.answers[i].answers : comment.answers;
            const answersArr: any = comment.answers;
            let rowAnswerNode = answersArr.find(
              a => a.questionId === sg.id && a._rowIndex === rowIndex
            );
            if (!rowAnswerNode) {
              const rowAns: ICommentAnswerRequestNode = {
                questionId: sg.id,
                answer: "", // table ans should always be empty
                answers: [],
                overrideStatus: 1, // adding new rows is overrideStatus=1
                _rowIndex: rowIndex
              };

              // if we're making changes and the rowId is empty, change it to a manual row override (including setting the rowId Q)
              const rowIdAnswer = rowIdQ ? row.cells[rowIdQ.id] : null;
              const updateRowIdQ =
                !row.rowAnswer ||
                (valueChanged && rowIdAnswer && !rowIdAnswer.answer);

              if (row.rowAnswer) {
                rowAns.id = row.rowAnswer.id;
                // maintain the original override status for row answers, except if we're updating the rowIdQ
                rowAns.overrideStatus = updateRowIdQ
                  ? 1
                  : row.rowAnswer.overrideStatus;
              }
              if (updateRowIdQ) {
                const a: any = {
                  questionId: rowIdQ.id,
                  answer: makeManualRowId(),
                  overrideStatus: 1
                };
                if (rowIdAnswer && rowIdAnswer.id != null) {
                  a.id = rowIdAnswer.id;
                }
                rowAns.answers.push(a);
              }
              answersArr.push(rowAns);

              rowAnswerNode = rowAns;
            }
            rowAnswerNode.answers.push(answer);
          }
        }
      } else {
        formControl = this.formGroup.controls[questionId];

        // find the existing answer from the subgroups
        let existingAnswer = null;

        const smartFormSubGroup = this.subGroups[questionId];
        const subGroupsArray = Object.values(this.subGroups) as ISubGroup[];
        subGroupsArray.forEach(sg =>
          sg.questions.forEach(q => {
            if (q.id === questionId && q.answers.length > 0)
              existingAnswer = q.answers[0];
          })
        );

        const originalAnswerValue =
          existingAnswer && existingAnswer.answer != null
            ? existingAnswer.answer
            : "";
        const formControlValue =
          formControl.value != null ? String(formControl.value) : "";
        const valueChanged = originalAnswerValue !== formControlValue;

        // Need to handle the case of comments without changing an answer
        const targetCf = { id: questionId, rowIndex };

        const isCommentOnly =
          !valueChanged &&
          this.commentFields.some(cf => commentFieldsMatch(cf, targetCf));

        if (valueChanged || isCommentOnly) {
          const answer: ICommentAnswerRequestNode = {
            questionId: questionId,
            answer: formControlValue,
            overrideStatus: isCommentOnly ? 0 : 1 // modifying any non-row/non-tab field in the UI is an override with status=1
          };

          if (existingAnswer) answer.id = existingAnswer.id;

          if (isCommentOnly && answer.id != null) {
            comment.forceAnswerIds.push(answer.id);
          } else {
            comment.answers.push(answer);
          }
        }
      }
    });

    // strip out modifications to tab questions where there are no changes
    comment.answers = comment.answers.filter(
      a =>
        a._saveIfEmpty === undefined || a._saveIfEmpty || a.answers.length > 0
    );

    // prompt to close any active answer warnings or flags
    const ansWarningAndFlagSubs = [];
    const checkAnsWarningsAndFlags = () => {
      this.savedAnswersWithFlags = [];
      this.savedAnswersWithWarnings = [];

      const pushWarningAndFlagAns = (answer: IAnswer) => {
        const ansWarnings: IAnswerWarning[] = this.answerWarnings.filter(
          aF => aF.answerId === answer.id && aF.status === 0
        );
        this.savedAnswersWithWarnings.push(...ansWarnings);
        const ansFlags: IAnswerFlag[] = this.answerFlags.filter(
          aF => aF.answerId === answer.id && aF.status === 0
        );
        this.savedAnswersWithFlags.push(...ansFlags);
      };

      const collectWarningsAndFlags = a => {
        if (a.id) {
          pushWarningAndFlagAns(a);
        }
        if (a.answers) {
          a.answers.forEach(aa => collectWarningsAndFlags(aa));
        }
      };

      comment.answers.forEach(a => collectWarningsAndFlags(a));

      const showAnsFlagsModal = () => {
        if (this.savedAnswersWithFlags.length > 0) {
          el(this.answerFlagsModal)
            .modal({
              closable: false,
              onApprove: () => {
                this.savedAnswersWithFlags.forEach(aF => {
                  const _comment: any = {
                    parentCommentId: aF.parentComment.id,
                    message: this.comment.value,
                    answerIds: [aF.answerId]
                  };
                  ansWarningAndFlagSubs.push(
                    this.commentService.addComment(_comment)
                  );
                });

                ansWarningAndFlagSubs.push(
                  this.answerService.updateAnswerFlag({
                    answerFlagIds: this.savedAnswersWithFlags.map(aF => aF.id),
                    status: 99
                  })
                );

                handleAnsWarningAndFlagSubs();
              },
              onDeny: () => {
                handleAnsWarningAndFlagSubs();
              }
            })
            .modal("show");
        } else {
          handleAnsWarningAndFlagSubs();
        }
      };

      const showAnsWarningsModal = () => {
        if (this.savedAnswersWithWarnings.length > 0) {
          el(this.answerWarningsModal)
            .modal({
              closable: false,
              onApprove: () => {
                this.savedAnswersWithWarnings.forEach(aW => {
                  const comment: any = {
                    message: this.comment.value,
                    answerIds: [aW.answerId],
                    answerWarningId: aW.id
                  };
                  ansWarningAndFlagSubs.push(
                    this.commentService.addComment(comment)
                  );
                });
                ansWarningAndFlagSubs.push(this.answerService.updateAnswerWarning({
                  answerWarningIds: this.savedAnswersWithWarnings.map(aW => aW.id),
                  status: 1
                }));

                showAnsFlagsModal();
              },
              onDeny: () => {
                showAnsFlagsModal();
              }
            })
            .modal("show");
        } else {
          showAnsFlagsModal();
        }
      };
      showAnsWarningsModal();
    };

    const handleAnsWarningAndFlagSubs = () => {
      if (ansWarningAndFlagSubs.length > 0) {
        // save sequentially as BE can't handle multiple async requests on comment route
        let length = 0;
        const sub = () => {
          ansWarningAndFlagSubs[length].subscribe(
            () => {
              length = length + 1;
              if (length < ansWarningAndFlagSubs.length) sub();
              else handlePostSave();
            },
            () => (this.isReady = false)
          );
        };
        sub();
      } else {
        handlePostSave();
      }
    };

    // after handling ans warnings and flags
    const handlePostSave = () => {
      this.getTaxReturn();
      this.fetchUpdatedSmartForm()
      // this.buildFormForSmartForm();
      this.comment.setValue("");
      this.commentDocumentMetadatas = [];
      this.isSaving = false;

      if (isCommentBox) {
        this.isReady = false;
      } else {
        el(this.saveModal)
          .modal({
            onHidden: () => {
              this.isReady = true;
            }
          })
          .modal("hide");
      }

      // clear the flag because they are no longer relevant to the new answer
      this.taxReturnSubcategoryService.setFlaggedAns(null);
      /*  this.flagTypeId = 0;
      this.flagsComment.setValue("");*/
    };

    this.commentService.addCommentWithAnswers(comment).subscribe(
      () => {
        checkAnsWarningsAndFlags();
        this.fetchUpdatedSmartForm()
        this.isSaving = false;
      },
      () => {
        // failed to add comment
        this.isSaving = false;
      }
    );
  }

  saveCheckEdits() {
    if (this.commentFields.length > 0 && !this.comment.value) {
      el(this.saveModal)
        .modal({
          onHidden: () => {}
        })
        .modal("show");
    } else if (this.comment.value) {
      this.save();
    }
  }

  isReadonly(): boolean {
    return false;
  }

  //RH sidebar functions
  handleSideOpen() {
    this.sideOpen = this.sideOpen ? !this.sideOpen : true;
  }
  readonlyAlwaysEditableQuestion() {
    return (
      !this.taxReturn ||
      this.taxReturn.snapshotId != null ||
      !this.taxReturn.assignedUser ||
      this.taxReturn.assignedUser.id !== this.userInfo.id ||
      this.taxReturn.assignee.status === 99 ||
      this.taxReturn.userIsReadOnly ||
      this.taxReturn.fullStatus.readOnly
    );
  }

  isQuestionAlwaysEditable(question: IFormField, rOnly: boolean) {
    const questionEditable =
      question && question.alwaysEditable
        ? undefined
        : !rOnly
        ? undefined
        : true;
    return (
      (!this.taxReturn ||
        this.taxReturn.snapshotId != null ||
        !this.taxReturn.assignedUser ||
        this.taxReturn.assignedUser.id !== this.userInfo.id ||
        this.taxReturn.assignee.status === 99 ||
        this.taxReturn.userIsReadOnly ||
        this.taxReturn.fullStatus.readOnly) &&
      !questionEditable
    );
  }

  disableClearOverRides() {
    return (
      this.isSyncingAps ||
      this.isRunningCalcs ||
      this.isClearingOverrides ||
      this.commentFields.length > 0
    );
  }

  hideOverrideIcon() {
    return (
      !this.disableClearOverRides() && this.overRideFlag !== "SINGLE ANSWER"
    );
  }

  async foreachSmartFormQuestion(callback: (smartFormQuestion: any) => void) {
    this?.smartForm.smartFormCategories?.forEach(sfC => {
      sfC?.smartFormSubCategories.forEach(sfSC => {
        sfSC?.smartFormQuestions.forEach(sfQ => {
          callback(sfQ); // TODO: make this work with async callbacks
        });
      });
    });
  }

  // NOTE(Brad) we need to build this without tables as they create a massive performance issue
  // we need to add form controls to the form group in real time on the FE rather than precomputing the form
  buildFormForSmartForm(deleted: boolean = false) {
    const formGroup = new UntypedFormGroup({});
    const nonTableQuestions = [];
    const seenQuestionIds = new Set();
    // if (this.smartForm.question) {
    //   nonTableQuestions.push(group.question);
    //   seenQuestionIds.add(group.question.id);
    // }

    // find table questions
    this.foreachSmartFormQuestion(sfQ => {
      if (
        sfQ.questions[0]?.displayFieldType === "table" &&
        !seenQuestionIds.has(sfQ.questionId)
      ) {
        this.subGroups[sfQ.questionId] = this.assignSubgroup(sfQ, true);
        seenQuestionIds.add(sfQ.questionId);
      }
    });

    this.foreachSmartFormQuestion(sfQ => {
      if (!seenQuestionIds.has(sfQ.questionId)) {
        nonTableQuestions.push(sfQ.questions[0]); // TODO fix this indexing issue with sfQ question field
        // seenQuestionIds.add(sfQ.questionId);
        this.subGroups[sfQ.questionId] = this.assignSubgroup(sfQ, false);
        const control = makeControlForQuestion(
          this.subGroups[sfQ.questionId].questions[0]
        );
        formGroup.addControl(sfQ.questionId, control);
        if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
      }
    });
    // group.subgroups.forEach(sg => {
    //   sg.questions.forEach(q => {
    //     if (!seenQuestionIds.has(q.id)) {
    //       nonTableQuestions.push(q);
    //       seenQuestionIds.add(q.id);
    //     }
    //   });
    // });

    // nonTableQuestions.forEach(q => {
    //   const control = makeControlForQuestion(q);
    //   formGroup.addControl(q.id, control);
    //   if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
    // });
    const subscriptions = setupDependantMandatory(
      undefined,
      nonTableQuestions,
      formGroup,
      this.taxReturn.questionsById,
      deleted ? null : null
    ); // TODO: Add back in "this.dependantMandatoryChanged"
    for (const s of subscriptions) {
      this.subscriptions.push(s);
    }
    return formGroup;
  }



  // checks if an answer has a notification. if subgroup is passed in, checks if a comment exists for any answers within subgroup
  // if subgroup is table, checks all row answers
  // by default, it returns all warnings/flags that are both inactive and active
  hasNotification: Function = (type: 'answerWarnings' | 'answerFlags' | 'comments', q: IFormField, answer?: IAnswer, activeOnly?: boolean): boolean => {

    const hasNotification: Function = (type: 'answerWarnings' | 'answerFlags' | 'comments', _answer?: IAnswer, _question?, _activeOnly?: boolean) => {
      if (type === 'answerWarnings') {
        return _answer && _answer.answerWarnings && (_activeOnly ? _answer.answerWarnings.filter(w => w.status === 0).length > 0 : _answer.answerWarnings.length > 0);
      }
      else if (type === 'answerFlags') {
        return _answer && _answer.answerFlags && (_activeOnly ? _answer.answerFlags.filter(f => f.status === 0).length > 0 : _answer.answerFlags.length > 0);
      }
      else if (type === 'comments')
        return _answer && _answer.comments && _answer.comments.filter(c => !c.answerWarningId && !c.answerFlagId).length > 0
    };

    return hasNotification(type, answer, q, activeOnly);

  }

  answerSelected: Function = (question, answer?: IAnswer, rowIndex?: number, row?: any): void => {
    // load trace
    if (this.rightSideTab === 'calculation') {
      this.loadTrace({ question, answer });
    }
    else if (this.tab === 3) {
      // flag answer
      if (!this.readonlyAlwaysEditableQuestion()) {
        const flagAns = cloneDeep(question);
        flagAns.answerId = answer && answer.id;
        if (rowIndex != null) {
          flagAns.rowIndex = rowIndex;
        }
        flagAns.row = row;
        this.taxReturnSubcategoryService.setFlaggedAns(flagAns);
      }
    }
    else if (this.tab === 2 && !this.readonlyAlwaysEditableQuestion()) {
      // comment
      const commentField = cloneDeep(question);
      commentField.rowIndex = rowIndex;
      this.taxReturnSubcategoryService.addCommentField(commentField);
    }
  }

  loadTrace({ question, answer }) {
    // reset state
    this.trace = null;
    this.traceQuestion = null;
    this.traceAnswer = null;
    // this.traceNotAvailable = false;
    if (this.loadingTrace) {
      this.loadingTrace.unsubscribe();
      this.loadingTrace = null;
    }
    // now load the trace
    if (question && answer) {
      this.loadingTrace = this.answerService.getAnswerTraceForAnswerId(answer.id).subscribe((trace: any) => {
        this.loadingTrace = null;
        this.traceQuestion = question;
        this.traceAnswer = answer;

        const snapshot = this.taxReturn.snapshot;
        if (snapshot) {
          // A trace is still valid if updatedAt was before the snapshot createdAt
          const date = moment(trace.updatedAt);
          if (moment(trace.updatedAt).isBefore(moment(snapshot.createdAt))) {
            this.trace = trace;
          }
        } else {
          this.trace = trace;
        }
      }, e => {
        this.loadingTrace = null;
        this.traceQuestion = question;
        this.traceAnswer = answer;
      });
    } else if (question) {
      this.traceQuestion = question;
    }
  }

  title() {
    if (this.activeCategory) {
      return this.activeCategory.name
    }else {
      return this.smartForm?.name;
    }
  }

  selectCategory(category, isHeader) {
    if (isHeader) {
      this.activeCategory = null
    }else {
      this.activeCategory = category
      category.collapsed = !category.collapsed
    }
    this.onCategoryChange();
  }

  onCategoryChange() {
    this.initWarnings();
    this.initFlags()
    this.filterDocuments();
  }

  countWarningsFlagsComments() {
    const categoryWithCount = this.smartForm.smartFormCategories.map(category => {
      let categoryAnswers = []
      let fileQuestion = {};
      let questions = []
      let validationWarnings = [];
      const smartFormSubCategoriesWithCount = category.smartFormSubCategories.map(subcategory => {
        const smartFormQuestionsWithCount = subcategory.smartFormQuestions.map(question => {

          //build subgroup for non table question
          if (question.questions[0]?.displayFieldType !== "table") {
            const nonTableSubgroup = this.buildSubgroupForNonTableQuestion(question)
            if (question.answers && !this.hiddenAndMandatoryMap[`question-${question.questionId}`].hidden) {
              categoryAnswers.push(...question.answers)
              //count count file question documents
              if (question.questions[0].displayFieldType === 'file') {
                question.answers.map(a => {
                  fileQuestion[a.answer] = true
                })
              }
            }
            if (nonTableSubgroup.questions[0].warningMessage) {
              validationWarnings.push(nonTableSubgroup.questions[0])
            }
            return {...question, subgroup: nonTableSubgroup}
          }else {
            const tableSubgroup = this.buildSubgroupForTableQuestion(question);
            if (tableSubgroup.rows && !this.hiddenAndMandatoryMap[`question-${tableSubgroup.id}`].hidden) {
              tableSubgroup.rows.map(r => {
                Object.values(r.cells).forEach((c: any) => {
                  categoryAnswers.push(c)
                  if (tableSubgroup.questions.some(q => q.id === c.questionId && q.displayFieldType === 'file')) {
                    fileQuestion[c.answer] = true
                  }

                })

              })
              tableSubgroup.questions.forEach(q => {
                if (q.warningMessage) {
                  validationWarnings.push(q)
                }
              })
            }
            return {...question, subgroup: tableSubgroup}
          }
        })
        questions.push(...smartFormQuestionsWithCount)
        return {...subcategory, smartFormQuestions: smartFormQuestionsWithCount}
      })
      this.initCommentUrlsAndDocuments(categoryAnswers);
      const uniqueCommentIds = uniqueCommentsForAnswers(categoryAnswers)
      const uniqueWarningIds = uniqueOpenWarningsForAnswers(categoryAnswers)
      const uniqueFlagIds = uniqueOpenFlagsForAnswers(categoryAnswers)
      let uniqueDocumentIds = uniqueDocumentsForAnswers(categoryAnswers)
      uniqueDocumentIds = {...uniqueDocumentIds, ...fileQuestion}

      return {
        ...category,
        smartFormSubCategories: smartFormSubCategoriesWithCount,
        commentCount: Object.keys(uniqueCommentIds).length,
        warningCount: Object.keys(uniqueWarningIds).length,
        flagCount: Object.keys(uniqueFlagIds).length,
        documentCount: Object.keys(uniqueDocumentIds).length,
        uniqueCommentIds,
        uniqueWarningIds,
        uniqueFlagIds,
        uniqueDocumentIds,
        questions,
        validationWarnings
      }
    })

    const sfUniqueCommentIds = mergeUniqueIds(categoryWithCount.map(obj => obj.uniqueCommentIds))
    const sfUniqueWarningIds = mergeUniqueIds(categoryWithCount.map(obj => obj.uniqueWarningIds))
    const sfUniqueFlagIds = mergeUniqueIds(categoryWithCount.map(obj => obj.uniqueFlagIds))
    const sfUniqueDocumentIds = mergeUniqueIds(categoryWithCount.map(obj => obj.uniqueDocumentIds))
    let sfQuestions = [];
    let sfValidationWarnings = [];
    categoryWithCount.forEach(obj => {
      sfQuestions = sfQuestions.concat(obj.questions)
      sfValidationWarnings = sfValidationWarnings.concat(obj.validationWarnings)
    })




    this.smarFormWithCount = {
      ...this.smartForm,
      smartFormCategories: categoryWithCount,
      commentCount: Object.keys(sfUniqueCommentIds).length,
      warningCount: Object.keys(sfUniqueWarningIds).length,
      flagCount: Object.keys(sfUniqueFlagIds).length,
      documentCount: Object.keys(sfUniqueDocumentIds).length,
      sfUniqueCommentIds,
      sfUniqueWarningIds,
      sfUniqueFlagIds,
      sfUniqueDocumentIds,
      sfQuestions,
      sfValidationWarnings
    }

  }

  initCommentUrlsAndDocuments(answers: any[]) {
    const commentDataById = {};
    const allDocuments = {};
    answers.forEach(answer => {
      answer?.comments?.forEach(comment => {
        let data = commentDataById[comment.id];
        if (data == null) {
          data = parseMessageForDocumentsAndUrls(comment.message || "");
          commentDataById[comment.id] = data;
          data.documents.forEach(d => allDocuments[d.id] = d);
        }
        comment.parts = data.parts;
        comment.documents = data.documents;
      });
    });
  }

  selectTab(tab: number) {
    this.tab = tab;
    this.taxReturnSubcategoryService.selectTab(tab);
  }

  initWarnings(){
    this.answerWarnings = [];

    const initAnswerWarnings = (a: IAnswer, q: Question, parentQuestion?, rowIndex?) => {

      if (!a.answerWarnings || a.answerWarnings.length === 0) return undefined;

      a.answerWarnings.forEach(answerWarning => {
        answerWarning.answer = a;
        answerWarning.question = q.question;
        answerWarning.questionId = q.id;
        if (!answerWarning.createdAtString) {
          answerWarning.createdAtString = moment(answerWarning.createdAt).format("MMMM Do YYYY, h:mm:ss a");
        }

        // find comments on the warning
        answerWarning.replies = [];
        a.comments.forEach(c => {
          if (c.answerWarningId === answerWarning.id) {
            answerWarning.replies.push(this.getCommentMeta(c));
          }
        });
        answerWarning.externalUrl = answerWarning.replies.find(c => !!c.externalUrl)?.externalUrl;
        answerWarning.replyTo = false;
        answerWarning.replyComment = { message: "", attachments: new Map() };
        const rowIndex = parentQuestion ? parentQuestion.answers.map(a => a.id).indexOf(answerWarning.answer.parentAnswerId) + 1 : null
        answerWarning.rowIndex = rowIndex ? rowIndex : null;
        answerWarning.isCollapsed = answerWarning.replies.length > this.maxNumOfComments
        this.answerWarnings.push(answerWarning);
      });
    };

    const getActiveQuestionAndAnswer = (q) => {
      if (q.answers && !this.hiddenAndMandatoryMap[`question-${q.questionId}`].hidden) {
        if (q.questions[0].displayFieldType === 'table') {
          q.subgroup.questions.forEach((colQ, index) => {
            q.dependentAnswers[index].forEach(a => {
              initAnswerWarnings(a, colQ, q)
            })
          })
        }else {
          q.subgroup.questions[0].answers.forEach(a => initAnswerWarnings(a, q.subgroup.questions[0]));
        }
      }
    }

    if (this.activeCategory) {
      const activeCategoryWithCount = this.smarFormWithCount.smartFormCategories.find(category => category.id === this.activeCategory.id)
      activeCategoryWithCount.questions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    } else {
      this.smarFormWithCount.sfQuestions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    }

  }

  // get count of active answer warnings plus all unanswered mandatory fields
  // when getting total count for active group or subgroup, the answer warnings are already filtered on init


  activeAnsWarnings(all?: boolean) {
    let count = this.smarFormWithCount.warningCount + this.smarFormWithCount.sfValidationWarnings.length
    this.validationWarnings = this.smarFormWithCount.sfValidationWarnings
    if (!all) {
      if (this.activeCategory) {
        this.smarFormWithCount.smartFormCategories.forEach(category => {
          if (category.id === this.activeCategory.id) {
            count = category.warningCount + category.validationWarnings.length
            this.validationWarnings = category.validationWarnings
          }
        })
      }
    }
    return count

  }

  saveAnsWarningReply(answerWarning: IAnswerWarning, message: string, closeWarning: boolean) {
    this.replyingWarning = true;

    const comment: any = {
      message: message,
      answerIds: [answerWarning.answerId],
      answerWarningId: answerWarning.id,
    };

    this.commentService.addComment(comment).subscribe(
      (response: any) => {
        const newComment = response.comment;
        if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
          newComment.commentAudits[0].user = response.user;
        }
        this.replyingWarning = false;
        handleUrlsForNewComment(this.taxReturnService, this.taxReturn, newComment).subscribe(hasNewDocs => {
          if (hasNewDocs) {
            this.onCategoryChange();
          }
        });

        answerWarning.answer.comments.push(newComment);
        if (closeWarning) {
          this.answerService.updateAnswerWarning({
            answerWarningIds: [answerWarning.id],
            status: 1
          }).subscribe(() => {
            answerWarning.replyTo = false;
            answerWarning.replyComment = { message: "", attachments: new Map() };
            answerWarning.status = 1; // cause the count to update immediately
            setTimeout(() => {
              this.initWarnings();
            });
          })
        }else {
          answerWarning.replyTo = false;
          answerWarning.replyComment = { message: "", attachments: new Map() };
          setTimeout(() => {
            this.initWarnings();
          });
        }
        this.fetchUpdatedSmartForm()
      }, e => {
        this.replyingWarning = false;
      });
  }

  filterDocuments() {
    this.fileQuestion = [];
    const filteredDocuments: { [docId: string]: IDocumentMetadata } = {};
    const accumulateDocumentsOnQuestions = (a, q) => {
      //count file question documents
      if (q.displayFieldType == 'file') {
        this.fileQuestion.push(a.answer)
      }
      a.comments.forEach(c => c.documents && c.documents.forEach(d => {
        filteredDocuments[d.id] = d;
      }))
    }
    const getActiveQuestionAndAnswer = (q) => {
      if (q.answers && !this.hiddenAndMandatoryMap[`question-${q.questionId}`].hidden) {
        if (q.questions[0].displayFieldType === 'table') {
          q.subgroup.questions.forEach((colQ, index) => {
            q.dependentAnswers[index].forEach(a => {
              accumulateDocumentsOnQuestions(a, colQ)
            })
          })
        }else {
          q.subgroup.questions[0].answers.forEach(a => accumulateDocumentsOnQuestions(a, q.subgroup.questions[0]));
        }
      }
    }
    if (this.activeCategory) {
      const activeCategoryWithCount = this.smarFormWithCount.smartFormCategories.find(category => category.id === this.activeCategory.id)
      activeCategoryWithCount.questions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    }else {
      this.smarFormWithCount.sfQuestions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    }

    const docs = Object.values(filteredDocuments);
    this.filteredDocuments = docs.map(d => this.taxReturn.documents.find(doc => doc.id === d.id));
    this.fileQuestion.map(fq => {
      this.filteredDocuments.push({url: fq})
    })
  }

  countDocuments(all?: boolean) {
    let count = this.smarFormWithCount.documentCount
    if (!all) {
      if (this.activeCategory) {
        this.smarFormWithCount.smartFormCategories.forEach(category => {
          if (category.id === this.activeCategory.id) {
            count = category.documentCount
          }
        })
      }
    }
    return count
  }

  initFlagsTab(){
    const initDropdown = () => {

      const valuesPlaceholder: {}[] = [{
        name: "Select...",
        value: "",
        order: 0
      }];

      const flagTypes: {}[] = this.flagTypes.flags.map(f => ({
        name: f.name, // the menu label
        value: f.id,
        selected: this.flagTypeId === f.id
      }));

      setTimeout(() => {
        this.flagDropDown = $(this.flagDropDown.nativeElement).dropdown({
          values: valuesPlaceholder.concat(flagTypes),
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          direction: 'upward',
          onChange: (value: string) => this.flagTypeId = Number(value)
        });
      });

    };

    !this.flagTypes ? this.flagService.getFlags().subscribe((f: ListOfFlags) => {
      this.flagTypes = f;
      initDropdown();
    }) : initDropdown();

    setTimeout(() => $(".scroll-anchor").get(0).scrollIntoView());

  }

    // init all answer flags
  initFlags() {

    this.answerFlags = [];

    const initFlag = (a: IAnswer, q: Question, rowIndex?) => {

      if (!a.answerFlags || a.answerFlags.length === 0) return undefined;

      a.answerFlags.forEach(aF => {

        const answerFlag: any = {
          ...aF,
          question: q,
          rowIndex: rowIndex,
          createdAtString: moment(aF.createdAt).format("MMMM Do YYYY, h:mm:ss a")
        };

        if (a.comments && a.comments.length > 0) {

          const flagComment = a.comments.find(c => c.answerFlagId === aF.id && !c.parentCommentId);

          if (flagComment) {
            answerFlag.parentComment = this.getCommentMeta(flagComment);
            // find replies to parent comment
            answerFlag.parentComment.comments = [];
            a.comments.forEach(cc => {
              if (cc.parentCommentId === answerFlag.parentComment.id)
                answerFlag.parentComment.comments.push(this.getCommentMeta(cc));
            });
            answerFlag.externalUrl = answerFlag.parentComment.comments.find(c => !!c.externalUrl)?.externalUrl;
          }
        }

        answerFlag.replyTo = false;
        answerFlag.isCollapsed = (answerFlag.parentComment)? answerFlag.parentComment.comments.length > this.maxNumOfComments: false;

        this.answerFlags.push(answerFlag);
      });
    };

    const getActiveQuestionAndAnswer = (q) => {
      if (q.answers && !this.hiddenAndMandatoryMap[`question-${q.questionId}`].hidden) {
        if (q.questions[0].displayFieldType === 'table') {
          q.subgroup.rows.forEach((r, rowIndex) => {
            Object.keys(r.cells).forEach(qId => {
              const cellAns = r.cells[qId].id;
              if (cellAns) {
                const question = q.subgroup.questions.find(q => q.id === Number(qId));
                initFlag(r.cells[qId], question, rowIndex);
              }
            });
          });
        }else {
          q.subgroup.questions[0].answers.forEach(a => initFlag(a, q.subgroup.questions[0]));
        }
      }
    }

    if (this.activeCategory) {
      const activeCategoryWithCount = this.smarFormWithCount.smartFormCategories.find(category => category.id === this.activeCategory.id)
      activeCategoryWithCount.questions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    } else {
      this.smarFormWithCount.sfQuestions.forEach(q => {
        getActiveQuestionAndAnswer(q)
      })
    }

    setTimeout(() =>
    $("#flags-tab .labels .label").popup({
      position: "top center",
      inline: false,
      variation: "inverted",
    }));

  }

  activeAnsFlags(all?: boolean) {
    let count = this.smarFormWithCount.flagCount
    if (!all) {
      if (this.activeCategory) {
        this.smarFormWithCount.smartFormCategories.forEach(category => {
          if (category.id === this.activeCategory.id) {
            count = category.flagCount
          }
        })
      }
    }
    return count
  }

  // prevent flagging ans if answers have changed
  // answer id is required to flag, if question contains no ans, save empty ans first
  saveAnsFlag() {
    const flaggedAns = this.taxReturnSubcategoryService.getFlaggedAns();
    if (this.commentFields.length > 0) {
      return $(this.unsavedFieldsModal.nativeElement).modal('show');
    }

    this.isSaving = true;

    const addAnswerFlag = answerId => {
      this.commentService.addComment({
        answerIds: [answerId],
        flagId: this.flagTypeId,
        message: this.flagsComment.value,
      }).subscribe(() => {
        this.isSaving = false;
        this.taxReturnSubcategoryService.setFlaggedAns(null);
        this.flagsComment.setValue("");
        this.isReady = false;
        this.getTaxReturn();
        this.fetchUpdatedSmartForm()
      }, e => {
        this.isSaving = false;
      });
    };

    if (flaggedAns.answerId) {
      addAnswerFlag(flaggedAns.answerId);
    } else {
      const groupId = flaggedAns.groupId;
      const tableQuestionId = flaggedAns.parentId;

      if (!tableQuestionId) {
        // saving a non-table answer, use the groupId as the parentAnswerId
        this.answerService.addAnswer({
          answer: "",
          questionId: flaggedAns.id,
          taxReturnId: this.getTaxReturnIdForCategory(),
          parentAnswerId: groupId ? groupId : null,
        }).subscribe(answer => {
          addAnswerFlag(answer.id);
        }, e => {
          this.isSaving = false;
        });
      } else {
        // saving a table-answer, the row answer may or may not exist
        const rowAnswer = flaggedAns.row && flaggedAns.row.rowAnswer;
        const newAnswerData = rowAnswer ? {
          questionId: flaggedAns.id,
          parentId: rowAnswer.id,
          answer: "",
        } : {
          questionId: tableQuestionId,
          parentId: groupId ? groupId : null,
          answer: "",
          overrideStatus: 0, // just adds a blank row, doesn't need to be an override given no answer change
          answers: [{
            questionId: flaggedAns.id,
            answer: "",
          }],
        };
        this.commentService.addCommentWithAnswers({
          comment: {
            createComment: false,
          },
          answers: [newAnswerData],
          taxReturnId: this.getTaxReturnIdForCategory(),
        }).subscribe(r => {
          const answerId = rowAnswer ? r.answers[0].id : r.answers[0].answers[0].id;
          addAnswerFlag(answerId);
        }, e => {
          this.isSaving = false;
        });
      }
    }
  }

  // submit a comment reply
  replyToFlag(answerFlag: IAnswerFlag, closeFlag?: boolean) {
    this.replyingFlag = true;

    const _comment: any = {
      parentCommentId: answerFlag.parentComment.id,
      message: answerFlag.replyComment.message,
      answerIds: [answerFlag.answerId]
    };

    this.commentService.addComment(_comment).subscribe((response: any) => {
      this.replyingFlag = false;
      const newComment = response.comment;
      if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
        newComment.commentAudits[0].user = response.user;
      }
      handleUrlsForNewComment(this.taxReturnService, this.taxReturn, newComment).subscribe(hasNewDocs => {
        if (hasNewDocs) {
          this.onCategoryChange();
        }
      });

      // append reply to parent comment
      answerFlag.parentComment.comments.push(this.getCommentMeta(newComment));

      if (closeFlag) {
        this.answerService.updateAnswerFlag({
          answerFlagIds: [answerFlag.id],
          status: 99
        }).subscribe(() => {
          answerFlag.replyTo = false;
          answerFlag.replyComment = { message: "", attachments: new Map() };
          answerFlag.status = 99;
          this.fetchUpdatedSmartForm()
        });
      } else {
        answerFlag.replyTo = false;
        answerFlag.replyComment = { message: "", attachments: new Map() };
      }
    }, e => {
      this.replyingFlag = false;
    });
  }

  unFlagAns() {
    this.taxReturnSubcategoryService.setFlaggedAns(null);
  }


  activeAnsComments(all?: boolean) {
    let count = this.smarFormWithCount.commentCount
    if (!all) {
      if (this.activeCategory) {
        this.smarFormWithCount.smartFormCategories.forEach(category => {
          if (category.id === this.activeCategory.id) {
            count = category.commentCount
          }
        })
      }
    }
    return count
  }


  // saves all answers then saves comment
  saveComment() {
    this.save(true);
  }

  updateCommentsCount() {
    this.commentsCount += 1;
  }

  updateGroupCommentsCount(count: number) {
    this.totalComments = count;
  }

  deleteCommentField(commentField: ICommentField) {
    this.taxReturnSubcategoryService.removeCommentField(commentField);
  }

  handleToggleFullScreen({ requiresFullScreen, subGroupId }) {
    this.isFullScreenMode = requiresFullScreen;
    if (requiresFullScreen) {
      this.previousSideOpen = this.sideOpen;
      this.sideOpen = false;
    } else {
      this.sideOpen = this.previousSideOpen;
    }
  }

  toggleInactiveQuestions() {
    // TODO: add function for show inactive quesitons button
  }

  goToSection (type: any, id: any)  {
    const newTab = window.open(`${this.baseUrl.get()}/settings/${type}/${id}`);
    newTab.blur();
    window.focus();
  }
  openQuestionInNewTab(triggeringQuestionId: number) {
    this.smartForm.smartFormCategories.forEach(category => {
      category.smartFormSubCategories.forEach(subcategory => {
        subcategory.smartFormQuestions.forEach(q => {
          if (q.questionId === triggeringQuestionId) {
            category.collapsed = false
          }
        })
      })
    })
    setTimeout(() => {
      if (triggeringQuestionId) {
        this.scrollToSegment(triggeringQuestionId)
      }
    }, 0);
  }

  getSubcategoryIdInTaxReturnByQuestionId(questionId: number) {
    let subCategoryId
    this.taxReturn.categories.forEach(c => {
      c.subcategories.forEach(sc => {
        if(sc.questions.some(q => q.id === questionId)) {
          subCategoryId = sc.id
        }
      })
    })
    return subCategoryId
  }

  countQuestionsInSubCategory(subCategory) {
    if (this.debug) {
      return subCategory?.smartFormQuestions?.length ?? 0
    }else {
      const displayedQuestions = subCategory?.smartFormQuestions.filter(q => !q.hidden)
      return displayedQuestions.length
    }
  }

  countQuestionsInCategory(category) {
    return category.smartFormSubCategories.reduce((count, subCategory) => {
      return count + this.countQuestionsInSubCategory(subCategory);
    }, 0,);
  }

  countQuestionsInSmartForm() {
    return this.smartForm.smartFormCategories.reduce((count, Category) => {
      return count + this.countQuestionsInCategory(Category);
    }, 0,);
  }

  scrollToSegment(fragment) {
    if ( fragment) {
      let el;
      el = $("#question-" + fragment).get(0);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        this.lastScrollFragment = fragment;
      }
    }
  }

  addAnswersToQuestions(smartForm) {
    return {
      ...smartForm,
      smartFormCategories: smartForm.smartFormCategories.map(sfCategory => ({
        ...sfCategory,
        smartFormSubCategories: sfCategory.smartFormSubCategories.map(sfSubCategory => ({
          ...sfSubCategory,
          smartFormQuestions: sfSubCategory.smartFormQuestions.map(sfQuestion => ({
            ...sfQuestion,
            questions: sfQuestion.questions.map(question => ({
              ...question,
              answers: sfQuestion.answers,
            })),
          })),
        })),
      })),
    }
  }

  showSendToClientButton(info) {
    return false
    // Hiding the send to client button, till the MI feature is supported.
    // if (this.tab === 1) {
    //   return this.isPublishedInOT && info.status === 0 && !info.rowIndex
    // }else if (this.tab === 3) {
    //   return this.isPublishedInOT && info.status === 0 && !info.rowIndex && info.flagId === 2
    // }else {
    //   return false
    // }
  }

  validateBatchMembership(answerFlagOrWarning, taxReturn, isWarning){
    const queryParams: SendWarningAndmissingInformationToClientRequest = {
      taxReturnId: taxReturn?.id,
      questionId: isWarning? answerFlagOrWarning?.questionId : answerFlagOrWarning?.question?.id
    };
    this.subscriptions.push(
    this.missingInformation.sendWarningAndmissingInformationToClient(queryParams).subscribe((response: WarningMissingInformation) =>  {
      if (response) {
        if (response.processState && !response.isSingleBatch){
           window.location.href=response.batchUrl
        } else {
          answerFlagOrWarning.replyToClient=true;
          answerFlagOrWarning.replyClient=(isWarning)? answerFlagOrWarning?.warningMessage : answerFlagOrWarning?.flag?.flagMessage;
        }
      }
    }));
  }

  sendAnsWarningReplyToClient(answerWarning: IAnswerWarning, message: string) {
    this.replyingWarning = true;
    const payload: SendAnsWarningToClientRequest = {
      taxReturnId: this.taxReturn?.id,
      questionId: answerWarning?.questionId,
      message: message,
      warningId: answerWarning.id,
      smartFormId: this.smartForm?.id,
      year: this.taxReturn.year,
      clientId: this.taxReturn?.assignee?.populations[0]?.client?.id
    };
    this.subscriptions.push(
    this.missingInformation.sendAnsWarningToClient(payload).subscribe((response) =>  {
      if (response) {
        this.replyingWarning = false;
        this.fetchUpdatedSmartForm()
      }
    }));
  }

  sendAnsFlagReplyToClient(answerFlag: IAnswerFlag, message: string, questionId: number) {
    this.replyingFlag = true;
    const payload: SendAnsFlagToClientRequest = {
      taxReturnId: this.taxReturn?.id,
      questionId: questionId,
      message: message,
      flagId: answerFlag.id,
      smartFormId: this.smartForm?.id,
      year: this.taxReturn.year,
      parentCommentId: answerFlag?.parentComment?.id,
      clientId: this.taxReturn?.assignee?.populations[0]?.client?.id
    };
    this.subscriptions.push(
    this.missingInformation.sendAnsFlagToClient(payload).subscribe((response) =>  {
      if (response) {
        this.replyingFlag=false;
        this.fetchUpdatedSmartForm()
      }
    }));
  }

  ngOnDestroy() {
    this.rubixDocumentService.setTaxReturnForImageUploads(null);
  }

}
